import React, { useEffect, useRef } from 'react';
import ChatBot from '../../flows/chatBot';
import { validateFeatureFlag } from '../../services/featureFlagService';
import { FEATURE_FLAG } from '../../constants/general';
import { STYLES } from './consts';
import { CustomerProfile } from '../CustomerProfile/CustomerProfile';
import { eventBus } from '../../services/eventBus';

interface IProps {
    children: React.ReactNode;
    shouldHideChatBot?: boolean;
    wrapperClassName?: string;
    shouldHideProfile?: boolean;
    childrenWrapperClassName?: string
}

export const Layout = ({
  children,
  shouldHideChatBot,
  wrapperClassName,
  shouldHideProfile,
  childrenWrapperClassName,
}: IProps) => {
  const elDashboardWrapper = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!elDashboardWrapper) return;
    elDashboardWrapper.current?.addEventListener('scroll', () => {
      const scrollPosition = elDashboardWrapper.current?.scrollTop;
      if ((scrollPosition || 0) >= 80) {
        eventBus.emit('closeProfileMenu', '');
      }
    });
  }, [elDashboardWrapper]);

  return (
    <div className={`${wrapperClassName || STYLES.WRAPPER}`}>

      {!shouldHideProfile && <CustomerProfile />}
      {validateFeatureFlag(FEATURE_FLAG.ADA_BETA) && !shouldHideChatBot
                && <ChatBot chatBotStyle={STYLES.CHATBOT} />}
      <div ref={elDashboardWrapper} className={childrenWrapperClassName || STYLES.CHILDREN}>{children}</div>
    </div>
  );
};
